<template>
  <div class="scroll-hide" :style="brand !== 'COTTI' ? {'background': '#F8F8F8'} : {}">
    <div v-if="!isLoading && scanQrCodeStatusCode === 0" class="ticket">
      <button class="cnt-button" @click.stop="doOpenRule">
        <div v-if="activityData.activityDesc" class="ticket-rule">
          <img class="rule-img" src="@/assets/ticket/rule.png" alt="" />
          <span class="rule-title">活动说明</span>
        </div>
      </button>

     <img v-if="activityData.publicityImg && activityData.publicityImg.url"
            :src="activityData.publicityImg.url" v-show="false" alt=""/>
      <img v-if="activityData.receivingPublicityImg && activityData.receivingPublicityImg.url"
      :src="activityData.receivingPublicityImg.url" v-show="false" alt="" />
      <img v-if="activityData.afterPublicityImg && activityData.afterPublicityImg.url"
      :src="activityData.afterPublicityImg.url" v-show="false" alt="" />

     <img v-if="activityData.publicityImg && activityData.publicityImg.url && !openEnvelope && !isReceived && !closeEnvelope" class="envelope-img" @click="openEnvelopeEvent()"
            :src="activityData.publicityImg.url" alt="" />
      <img v-if="activityData.receivingPublicityImg && activityData.receivingPublicityImg.url && openEnvelope" class="envelope-img"
      :src="activityData.receivingPublicityImg.url" alt="" />
      <img v-if="activityData.afterPublicityImg && activityData.afterPublicityImg.url && closeEnvelope" class="envelope-img" style="z-index: 1000"
      :src="activityData.afterPublicityImg.url" alt="" />

      <div :style="activityData.backgroundImgSecurityZoneHeight ? {top: ((activityData.backgroundImgSecurityZoneHeight - 28) * 2) /200 + 'rem'} : {top:180 + 'px'}" class="coupon" v-if="closeEnvelope">
        <div class="coupon-text" v-if="randomPrize == 1 && activityData.afterPublicityImg && activityData.afterPublicityImg.url">{{ receiveContent }}</div>
        <div class="coupon-name" v-if="randomPrize == 1 && activityData.afterPublicityImg && activityData.afterPublicityImg.url">{{ couponName }}</div>
      </div>
     <div>

        <img v-if="activityData.backgroundImg && activityData.backgroundImg.url" class="ticket-bg-img"
        :src="activityData.backgroundImg.url" alt="" />
     </div>
    <div class="box_ticket">
        <div v-if="activityData.publicityImg && activityData.publicityImg.url" class="publicity-picture">
        </div>
        <div v-else class="publicity-picture" style="height: 310px" />
      </div>
      <div v-if="loading" class="error" :class="brand=='COTTI' ? 'error_bg' : 'error_bg_tc'">
        <div v-if=isErr>
          <img v-if="brand=='COTTI'" class="is_error" src="https://cdn-arch-common-prod.cotticoffee.com/cottih5/cotti-hot-limit.png" alt="" />
          <img v-else class="is_error" src="https://cdn-arch-common-prod.cotticoffee.com/cottih5/tc-hot-limit.png" alt="" />
          <div class="is_err_title">
            <img v-if="brand=='COTTI'" class="is_err_img" src="https://cdn-arch-common-prod.cotticoffee.com/cottih5/cotti-hot-img.png" alt="" />
            <img v-else class="is_err_img" src="https://cdn-arch-common-prod.cotticoffee.com/cottih5/tc-hot-img.png" alt="" />
            <div class="is_err_text"  :class="brand=='COTTI' ? 'error_text' : 'error_text_tc'">活动太火爆！请稍后再试～</div>
          </div>
        </div>


      </div>
      <div v-else-if="activityLost" class="lost">
        <img v-if="brand=='COTTI'" class="lost-img" src="https://cdn-arch-common-prod.cotticoffee.com/cottih5/activity-lost-1.png" alt="" />
        <img v-else class="lost-img" src="https://cdn-arch-common-prod.cotticoffee.com/cottih5/tc-activity-lost.png" alt="" />
        <div class="lost_title">活动走丢了</div>
        <div v-if="brand=='COTTI'" class="lost_text" >来杯咖啡放松下</div>
        <div v-else class="lost_text" >来杯奶茶放松下</div>
      </div>


      <div v-else class="box_ticket" :style="activityData.backgroundImgSecurityZoneHeight ? {top: (activityData.backgroundImgSecurityZoneHeight * 2) /100 + 'rem'} : {top:400 + 'px'}">

        <div v-if="activityData.couponsComponent && activityData.coupons && activityData.coupons.length === 1"
          class="ticket-single" :style="getStyle(activityData.couponsComponent)">
          <div class="single-content" v-for="(coupon, index) in activityData.coupons" :key="index">
            <span class="content-item content-item-price">
              <div style="display: flex; align-items: center">
                <span v-if="coupon.couponType === 1" class="price-unit">￥</span>
                <span v-if="coupon.couponType === 1 || coupon.couponType === 2" class="price-num">
                  {{ coupon.value && Number(coupon.value) }}
                </span>
                <span v-if="coupon.couponType === 2" class="price-unit">折</span>
                <span v-if="coupon.couponType === 3" class="price-name">兑换商品</span>
              </div>
              <span class="name-num">{{ coupon.couponDesc }}</span>
            </span>
            <span class="content-item content-item-name">
              <div class="name-text">{{ coupon.couponName }}</div>
            </span>
            <span class="content-item-type">
              <span v-if="coupon.couponType === 1" class="type-name">立减券</span>
              <span v-if="coupon.couponType === 2" class="type-name">折扣券</span>
              <span v-if="coupon.couponType === 3" class="type-name">兑换券</span>
            </span>
          </div>
        </div>
        <!-- 优惠券 -->
        <div v-if="activityData.couponsComponent && activityData.coupons && activityData.coupons.length > 1"
          class="ticket-multiple" :style="getStyle(activityData.couponsComponent)">
          <div v-if="activityData.couponName" class="multiple-header">{{ activityData.couponName }}</div>
          <div class="multiple-main">
            <div class="multiple-content" v-for="(coupon, index) in activityData.coupons" :key="index">
              <span class="content-item content-item-price">
                <div style="display: flex; align-items: center">
                  <span class="price-unit" v-if="coupon.couponType === 1">￥</span>
                  <span v-if="coupon.couponType === 1 || coupon.couponType === 2" class="price-num">
                    {{ coupon.value && Number(coupon.value) }}
                  </span>
                  <!--一口价券-->
                  <template v-if="coupon.couponType === 62">
                    <span class="price-unit">￥</span>
                    <span class="price-num">{{ coupon.value && Number(coupon.value) }}</span>
                    <span class="price-change-buy">换购</span>
                  </template>
                  <span v-if="coupon.couponType === 2" class="price-unit">折</span>
                  <span v-if="coupon.couponType === 3" class="price-name">兑换商品</span>
                </div>
                <span class="name-num">{{ coupon.couponDesc }}</span>
              </span>
              <span class="content-item content-item-name">
                <div class="name-text">{{ coupon.couponName }}</div>
              </span>
            </div>
          </div>
        </div>

        <div class="unsupport-wrapper" v-if="!isSupport">
          <div>抱歉</div>
          <div class="unsupport-desc">当前门店暂不支持此活动</div>
          <div>感谢您对{{ brandName }}的关注</div>
          <operation v-if="isShowOperation" :operationComponent="activityData && activityData.wechatActivityComponent" :is-advertise="advertiseUrl && advertiseUrl!=='' && activityData.status === 3 || activityData.status === 4"  :prop-data="{freeOrderActivity: this.activityData?.freeOrderActivity, activityNo: activityNo}" @operationClick="openApplet" />
        </div>

        <!-- 我的 -->
        <div v-if="noReceived && !isReceived" class="ticket-receive" :style="getStyle(activityData.receiveRewardComponent)">
          <div class="receive-title">
            <span class="text">抱歉</span>
          </div>
          <div class="receive-phone">暂不满足领券条件</div>
          <div class="text">感谢您对{{ brandName }}的关注</div>
          <operation v-if="isShowOperation" :operationComponent="activityData && activityData.wechatActivityComponent" :is-advertise="advertiseUrl && advertiseUrl!=='' && activityData.status === 3 || activityData.status === 4"  :prop-data="{freeOrderActivity: this.activityData?.freeOrderActivity, activityNo: activityNo}" @operationClick="openApplet" />
        </div>


        <div v-if="isSupport && !phone && (!isReceived || btnDisable) && Number(this.linkTerminal) !== 3 && (!isInMiniApp || !poi) && Number(this.linkTerminal) !== 4"  class="ticket-user" :style="getStyle(activityData.receiveRewardComponent)">
          <div class="user-wrapper">
            <van-field key="mobile" v-model="mobile" type="digit" maxlength="11" placeholder="请输入手机号码" />
          </div>
          <div class="user-wrapper passwd-item">
            <van-field key="code" v-model="smsCode" type="digit" placeholder="请输入验证码" :maxlength="smsCodeMax">
              <template #button>
                <div class="button-warpper">
                  <div v-if="isSmsSend" class="code-action code-action__disabled" v-html="sendBtnText" />
                  <div v-else class="code-action" @click="handleSendSmsCode">
                    {{ sendBtnText }}
                  </div>
                </div>
              </template>
            </van-field>
          </div>
          <div class="user-wrapper privacy">
            <van-radio-group v-model="agree" @change="changeAgree">
              <van-radio name="isClick" checked-color="#A52337" @click.native="isAgree" class="radio">
              <template #icon="props" >
                <img v-if="brand == 'COTTI' && props.checked" src="~@/assets/ticket/agree.png" class="img">
                <img v-else-if="brand !== 'COTTI' && props.checked" src="~@/assets/ticket/agree-tc.png" class="img">
              </template>
                <span class="text">我已认真阅读并同意</span>
                <span class="text click-text" @click.stop="toService()">《用户协议》</span>
                <span class="text">与</span>
                <span class="text click-text" @click.stop="toPrivacy()">《隐私政策》</span>
                </van-radio>
            </van-radio-group>
          </div>
          <div class="captcha-notice" v-if="!!codeTypeData">
            {{ codeTypeData.content }}
          </div>
          <div class="user-action" :style="btnDisable ? {opacity: 0.55} : {}">
            <button class="cnt-button radius" @click="handleSubmitAction" :disabled="btnDisable" >
              <img
                :src="activityData.receiveRewardComponent && activityData.receiveRewardComponent.buttonImgs && activityData.receiveRewardComponent.buttonImgs.length && activityData.receiveRewardComponent.buttonImgs[0].url"
                alt=""/>
            </button>
          </div>
          <operation v-if="isShowOperation" :operationComponent="activityData && activityData.wechatActivityComponent" :is-advertise="advertiseUrl && advertiseUrl!=='' && activityData.status === 3 || activityData.status === 4" :prop-data="{freeOrderActivity: this.activityData?.freeOrderActivity, activityNo: activityNo}" @operationClick="openApplet" />
        </div>

        <!-- 我的 领券前按钮-->
        <div v-else-if="(phone == '' || !phone) && (!isReceived || btnDisable) && ((isInMiniApp && poi) || Number(this.linkTerminal) === 3)" class="ticket-receive" :style="getStyle(activityData.receiveRewardComponent)">
          <div class="receive-title">
            <span class="text">领取到您的 {{ brandName }} 账号</span>
          </div>
          <div class="receive-action" :style="btnDisable ? {opacity: 0.55} : {}">
            <button class="cnt-button" @click="toPage('packages/common/login/index')">
              <img
                :src="activityData.receiveRewardComponent && activityData.receiveRewardComponent.buttonImgs && activityData.receiveRewardComponent.buttonImgs.length && activityData.receiveRewardComponent.buttonImgs[0].url"
                alt="" />
            </button>
          </div>
          <operation v-if="isShowOperation" :operationComponent="activityData && activityData.wechatActivityComponent" :is-advertise="advertiseUrl && advertiseUrl!=='' && activityData.status === 3 || activityData.status === 4" :prop-data="{freeOrderActivity: this.activityData?.freeOrderActivity, activityNo: activityNo}" @operationClick="openApplet" />
        </div>

        <!-- 我的 领券前按钮-->
        <div v-else-if="phone && (!isReceived || btnDisable)" class="ticket-receive" :style="getStyle(activityData.receiveRewardComponent)">
          <div class="receive-title">
            <span class="text">领取到您的 {{ brandName }} 账号</span>
          </div>
          <div class="receive-phone">{{ phone }}</div>
          <div class="receive-action" :style="btnDisable ? {opacity: 0.55} : {}">
            <button class="cnt-button" @click="handleRecieveAction" :disabled="btnDisable" :style="btnDisable ? {opacity: 0.55} : {}">
              <img
                :src="activityData.receiveRewardComponent && activityData.receiveRewardComponent.buttonImgs && activityData.receiveRewardComponent.buttonImgs.length && activityData.receiveRewardComponent.buttonImgs[0].url"
                alt="" />
            </button>
          </div>
          <operation v-if="isShowOperation" :operationComponent="activityData && activityData.wechatActivityComponent" :is-advertise="advertiseUrl && advertiseUrl!=='' && activityData.status === 3 || activityData.status === 4"  :prop-data="{freeOrderActivity: this.activityData?.freeOrderActivity, activityNo: activityNo}" @operationClick="openApplet" />
        </div>

        <!-- status !== 1 -->
        <div v-if="isReceived && !btnDisable" class="ticket-received" :style="getStyle(activityData.receiveRewardComponent)" >
          <div class="received-title" v-if="frontContentShowResult.couponShowName !== ''">{{frontContentShowResult.contentShowPrefix}}</div>
          <div class="received-new-title" v-else>{{frontContentShowResult.contentShowPrefix}}</div>
            <div class="received-bag" v-if="frontContentShowResult.couponShowName !== ''">{{ frontContentShowResult.couponShowName}}</div>
            <div class="received-phone">
            {{frontContentShowResult.contentShowAfter}}
            </div>

            <!-- 领券后按钮(status !== 1 3 4) -->
            <div
              v-if="activityData.receiveRewardComponent && activityData.receiveRewardComponent.buttonImgs && activityData.receiveRewardComponent.buttonImgs.length > 1 && unReceiveCoupon"
              class="received-action" style="position: relative">
              <button class="cnt-button" @click="handleJumpAction(activityData?.receiveRewardComponent?.jumpLink, activityData?.receiveRewardComponent?.h5UrlJumpType )">
                <img :src="activityData.receiveRewardComponent.buttonImgs[1].url" alt="" />
              </button>
            </div>
            <operation v-if="isShowOperation" :operationComponent="activityData && activityData.wechatActivityComponent" :is-advertise="advertiseUrl && advertiseUrl!=='' && activityData.status === 3 || activityData.status === 4" :prop-data="{freeOrderActivity: this.activityData?.freeOrderActivity, activityNo: activityNo}" @operationClick="openApplet" />
            
            <!-- 活动已下架or活动已结束跳转 -->
            <div v-if="activityData.status === 3 || activityData.status === 4" class="received-action no-received">
              <button class="cnt-button ctn-ad" @click="goToUrl()">
                <img :src="advertiseUrl" alt="" />
              </button>
            </div>
        </div>

        <!-- 免单记录栏 -->
         <!--  -->
        <free-order-record class="shop-receive" :activityNo="activityNo" v-if="activityData.freeOrderActivity && activityData.activityStatus == 2"></free-order-record>

        <!-- 附近门店 -->
        <div v-if="nearbyShopList.length" class="shop-receive">
          <div class="activity-title">{{ popTitle }}</div>
          <div class="activity-desc">{{ copyWriting }}</div>
          <shop-item
            v-for="item in nearbyShopList"
            :key="item.shopMdCode"
            :id="item.shopMdCode"
            :item="item"
            :linkTerminal="linkTerminal"
          />
        </div>

        <!-- 看看大家手气 -->
        <div v-if="couponRecordList.length > 0" class="shop-receive">
          <div class="activity-title">看看大家手气</div>
          <div class="max-receive">
            <coupon-record
                v-for="(item, index) in couponRecordList"
                :key="item.memberId"
                :id="item.memberId"
                :item="item"
                :lastIndex="index == couponRecordList.length - 1"
              />
          </div>
        </div>
        <div class="bottom-height"></div>
      </div>

      <PopupContainer
        :brand="brand"
        :brandName="brandName"
        :modelShow="modelShow"
        :modelTitle="modelTitle"
        :modelBtnStr="modelBtnStr"
        :modelSuccessShow="modelSuccessShow"
        :modelSuccessTitle="modelSuccessTitle"
        :modelSuccessBtnStr="modelSuccessBtnStr"
        :twoBtnModelShow="twoBtnModelShow"
        :twoBtnModeTitle="twoBtnModeTitle"
        :twoBtnModeBtnStr="twoBtnModeBtnStr"
        :ispopup="ispopup"
        :openRule="openRule"
        :contentFormatter="contentFormatter"
        :isGroupGift="isGroupGift"
        :groupGiftTitle="groupGiftTitle"
        :goApplet_1="goApplet_1"
        :originalAppId="originalAppId"
        @leftClick="leftClick"
        @rightClick="rightClick"
        @popupDel="popup_del"
        @goCommunity="goCommunity"
        @closeRule="doCloseRule"
        @groupGiftClick="groupGiftClick"
        @closeModelShow="closeModelShow"
        @closeModelSuccessShow="closeModelSuccessShow"
      />
    </div>
    <div v-else-if="!isLoading && (scanQrCodeStatusCode === 27 || scanQrCodeStatusCode === 37 || scanQrCodeStatusCode === 38 || scanQrCodeStatusCode === 39)">
      <QueryInfo :mode="scanQrCodeStatus" :linkTerminal="linkTerminal"></QueryInfo>
    </div>
  </div>
</template>

<script>
import weixinMixin from "../../mixins/wexin-mixin";
import { isPhone } from "../../utils/validate";
import {
  getCustomerSmsCodeOL,
  marketingShareH5Act,
  marketingGetH5Activity,
  marketingReceiveRewardH5,
  getCustomerCheckSmsCodeH5,
  getNearByShop,
  getCouponRecord,
  } from "../../api";
import wx from "weixin-js-sdk";
import { isWeixin, isAndroid, isIOS, isCottiApp, isWxMiniProgram } from "@/utils";
import { getWeChatScheme, getAdvertiseApi } from "../../api";
import {launchApp} from '../../utils/index';
import shopItem from './components/shop-item.vue';
import { Base64 } from 'js-base64'
import CouponRecord from './components/coupon-record.vue';
import QueryInfo from '../redirect/components/query-info.vue'
import FreeOrderRecord from './components/freeOrder/index.vue'
import PopupContainer from './components/PopupContainer.vue'
import Operation from './components/operation.vue'

export default {
  components: {shopItem, CouponRecord,QueryInfo, FreeOrderRecord, PopupContainer, Operation},
  name: "Ticket",
  mixins: [weixinMixin],
  computed: {
    contentFormatter() {
      if (!this.activityData.activityDesc) return '';
      return this.activityData.activityDesc.replace(/\n/g, '<br/>');
    },
    isShowOperation() {
      // return true
      return isWeixin() && isWxMiniProgram() && this.activityData.wechatActivityComponent && this.activityData.wechatActivityComponent.activityButtonList && this.activityData.wechatActivityComponent.activityButtonList.length > 0;
      // return this.operationList && this.operationList.length > 0;
    }
  },
  data() {
    return {
      brand: this.$config.env.VUE_APP_BRAND,
      brandName: 'Cotti',
      activityLost: false,
      show: true,
      scanQrCodeStatus: 'NOT_FOUND',//扫码之后的状态 37:QRCODE_INVALID: 二维码已失效，请重新扫码  38:抱歉，活动仅限扫码参与'
      scanQrCodeStatusCode: 0,//扫码之后的状态 37:QRCODE_INVALID: 二维码已失效，请重新扫码  38:抱歉，活动仅限扫码参与'
      mobile: null,
      smsCode: null,
      smsCodeMax: 6,
      codeTypeData: undefined,
      sendBtnText: "获取验证码",
      isSmsSend: false,
      counter: 60,
      shareData: null,
      activityData: {},
      comefrom: null,
      openId: null,
      utmSource: '',
      channelType: '',
      phone: '',
      isReceived: false,
      // isReceivedInitial: false, //从活动详情获取的初始
      // isReceivedInitials: false,
      // todayReceived: false, // 今日是否已领取
      isLoading: true,
      openTIme: false,
      // 是否跳转app
      goApp: false,
      // 是否在app中
      isInAndroid: false,
      isInIos: false,
      // 是否跳转小程序
      goApplet: false,
      goApplet_1: false,
      // 跳转链接
      appletUrl: "",
      // 判断是否是微信平台
      isWeixinPlatform: false,
      // 判断是否是小程序中
      isInMiniApp: false,
      ispopup: false, // false
      activityNo: "",
      isSupport: true,
      // 领券按钮是否可点击
      isTick: true,
      // 入群有礼弹窗状态
      isGroupGift: false,
      // 入群有礼弹窗标题
      groupGiftTitle: "",
      openRule: false,
      modelShow: false,
      modelTitle: '',
      modelBtnStr: '',
      twoBtnModelShow: false,
      twoBtnModeTitle: '',
      twoBtnModeBtnStr: ['', ''],
      // activityEnded: false,
      platform: '',
      unReceiveCoupon: false,    // 是否领过券 false没领过 true领过
      /// 链接商配置的终端类型（营销后台配置）  1、小程序 2、h5 3、APP
      linkTerminal: null,
      modelSuccessShow: false,
      modelSuccessTitle: '',
      modelSuccessBtnStr: '',
      activityNotStart: false,
      agree: '',
      agreeFlag: false,
      code: null,
      walkDistanceRange: 0,
      borderLetter: null,
      markTypeDesList: [],
      prizeCouponList: [],
      shopMdCode: '',   // 门店code
      launchCode: '',   //加密活动编号
      popTitle: '',  //附近门店活动标题
      copyWriting: '',  //附近门店活动说明
      frontContentShowResult: {},
      location: {
        latitude : null, //纬度
        longitude: null //经度
      },
      couponRecordList: [],
      enableStatus: false, //是否开启附近门店组件
      noReceived: false,
      couponList: [],
      citycode: null,
      nearbyShopList: [],
      input_focus: true,
      isCouponRecord: false,
      openEnvelope: false,
      closeEnvelope: false,
      memberId: null,
      closeIcon: false,
      couponName: '',
      text: '哎呀，不错呦！',
      receiveContent: '',
      btnDisable: false,
      poi: false,
      token: '',
      advertiseUrl: '',
      randomPrize: 0, //是否随机奖品
      loading: true,
      isErr: false,
      blackbox: '',
      operationComponent: {
        backgroundImg:"",
        activityButtonList: [
        {
          jumpLink: 'https://mp.weixin.qq.com/s/bavD75_7p9_VEOrGm6yvdQ',
          buttonImg: ''
        },
        {
          jumpLink: 'https://mp.weixin.qq.com/s/0n4592f0256035333436w',
          buttonImg: ''
        }
      ]
      }
    };
  },
  filters: {
    pwdCard(value) {
      if (isPhone(value)) {
        const start = value.slice(0, 3);
        const end = value.slice(-4);
        let strs = value;
        strs = strs.replace(/./g, "*");
        const newStr = start + "" + strs.slice(3, -4) + "" + end;
        return newStr;
      } else {
        return "****";
      }
    }
  },
  created () {
    var kuaishouScript = document.createElement('script')
    kuaishouScript.type = "text/javascript"
    kuaishouScript.text =`(function (root) {    var ksscript = document.createElement('script');    ksscript.setAttribute('charset', 'utf-8');    ksscript.src = '//p1-yx.adkwai.com/udata/pkg/ks-ad-trace-sdk/ks-trace.3.2.0.min.js';    var s = document.getElementsByTagName('script')[0];    s.parentNode.insertBefore(ksscript, s);})(window);`
    document.head.appendChild(kuaishouScript);
    this.launchCode = this.$route.query?.launchCode;
    var tongdunScript = document.createElement('script');
    tongdunScript.type = "text/javascript"
    if (process.env.VUE_APP_ENV === 'prod' ) {
      tongdunScript.text = `(function(){
        window._fmOpt = {
          partner: 'cotticoffee',
          appName: 'cotticoffee_h5',
          success: function(data) {
            window.blackbox = data
          }
        };
        var fm = document.createElement('script'); 
        fm.type = 'text/javascript'; fm.async = true;
        fm.src = 'https://static.trustdecision.com/tdfp/cn/7fa1350e97bf428376d94c6dba4103cc/fm.js' + '?t=' + (new Date().getTime()/3600000).toFixed(0);
        var s = document.getElementsByTagName('script')[0]; 
        s.parentNode.insertBefore(fm, s);
      })();`
    } else {
      tongdunScript.text = `(function(){
        window._fmOpt = {
          partner: 'cotticoffee',
          appName: 'cotticoffee_test',
          success: function(data) {
            window.blackbox = data
          }
        };
        var fm = document.createElement('script'); 
        fm.type = 'text/javascript'; fm.async = true;
        fm.src = 'https://static.trustdecision.com/tdfp/cn/7fa1350e97bf428376d94c6dba4103cc/fm.js' + '?t=' + (new Date().getTime()/3600000).toFixed(0);
        var s = document.getElementsByTagName('script')[0]; 
        s.parentNode.insertBefore(fm, s);
      })();`
    }
    document.head.appendChild(tongdunScript);
    
    // this.isErr = true
  },
  async mounted() {
    this.brandName = this.brand === 'COTTI' ? 'Cotti' : '茶猫'
    this.isWeixinPlatform = isWeixin();
    this.isInAndroid = isAndroid();
    this.isInIos = isIOS()
    // this.hanglePageInit()
    this.isInMiniApp = await this.isMiniProgram()
    const mmm = this.$route.query.mmm;
    this.linkTerminal = this.$route.query.a;
    this.isCouponRecord = this.$route.query?.requiredUserInfo;

    if (Number(this.linkTerminal) === 3 || Number(this.linkTerminal) === 4) {
      if (mmm && mmm.includes("OL")) {
        this.mobile = mmm.replace('OL', '');
      }
    }
    if (this.$route.query?.u_t) {
        this.token = this.$route.query?.u_t
    } else {
      this.token = ''
    }
    this.goApplet_1 = this.isWeixinPlatform && !this.isInMiniApp;
  },
  methods: {
    // 动态加载高德地图脚本
    loadAmapScript() {
      return new Promise((resolve, reject) => {
        // 检查是否已经加载过
        if (window.AMap) {
          resolve(window.AMap);
          return;
        }
        try {
          // 设置安全配置
          window._AMapSecurityConfig = {
            securityJsCode: "48c3c845b1c6906c78589e4a33a9c7f0",
          };
          // 创建脚本元素
          const script = document.createElement('script');
          script.type = 'text/javascript';
          script.src = 'https://webapi.amap.com/maps?v=2.0&key=7c25535c735245013e9131316d444982&plugin=AMap.Geolocation';
          script.async = true;
          // 脚本加载完成回调
          script.onload = () => {
            if (window.AMap) {
              resolve(window.AMap);
            } else {
              reject(new Error('高德地图加载失败'));
            }
          };
          // 脚本加载错误回调
          script.onerror = () => {
            reject(new Error('高德地图加载失败'));
          };
          // 添加到页面
          document.head.appendChild(script);
        } catch (error) {
          reject(error);
        }
      });
    },
    // 获取定位
    async getAmap() {
      const that = this;
      try {
        // 动态加载高德地图脚本
        await this.loadAmapScript();
        
        // 使用高德地图定位功能
        await AMap.plugin("AMap.Geolocation", () => {
          var geolocation = new AMap.Geolocation({
            // 是否使用高精度定位，默认：true
            enableHighAccuracy: true,
            //是否使用安卓定位sdk用来进行定位，需要安卓端sdk配合
            useNative: true,
            // 设置定位超时时间，默认：无穷大
            timeout: 10000,
            needAddress: true,
          });
          geolocation.getCurrentPosition((status, result) => {  //获取用户当前的精确位置
            if (status == "complete") {
              let data = result.addressComponent
              console.log(data, '定位信息')
              //重点：设置了needAddress属性 定位返回的信息回包含addressComponent对象，里面返回的内容跟regeo请求返回addressComponent 对象一致。
              if (data.adcode) {
                that.citycode = Number(data.adcode)
                that.location.latitude = result.position.lat.toString()
                that.location.longitude = result.position.lng.toString()
                that.getLocation()
              }
            }
          })
        });
      } catch (error) {
        console.error('高德地图加载或定位失败:', error);
        // 可以在这里添加错误处理逻辑，比如使用备用定位方式或提示用户
      }
    },
    // 获取广告位
    async getAdButton (code) {
      if (this.brand === 'COTTI') {
        const {data} = await getAdvertiseApi({code: code || 'cotti-mkt-getCoupons-longTail'})
        this.advertiseUrl = data[0]?.url || ''
      } else {
        const {data} = await getAdvertiseApi({code: code || 'teacat-mkt-getCoupons-longTail'})
        this.advertiseUrl = data[0]?.url || ''
      }
    },
    // 获取附近门店
    getLocation () {
      if (this.couponList.length > 0 || (this.activityData && this.activityData.prizeCouponListShop && this.activityData.prizeCouponListShop.length > 0)) {
        getNearByShop({
          memberId: this.memberId,
          cityMdCode: this.citycode,
          selectType: 1,
          couponList: this.couponList && this.couponList.length > 0 ? this.couponList : this.activityData.prizeCouponListShop.map(item => item.couponNo),
          latitude: this.location.latitude || null, // 39.16142605251736 || 
          longitude: this.location.longitude || null, // 117.39025661892362 || 
          activityNo: this.activityNo
        }).then((res) => {
          if (res.code == 200) {
            this.popTitle = res.data.popTitle
            this.copyWriting = res.data.copyWriting
            if (res.data.shopListResults !== null) {
              this.nearbyShopList = res.data.shopListResults
            }
          }
        })
      }
    },

    async hanglePageInit(openId) {
      this.openId = openId || null;
      const comefrom = this.$route.query.comefrom;
      const activityNo = this.$route.query?.activityNo || '';
      this.utmSource = this.$route.query.utm_source;
      this.channelType = this.$route.query.channelType;
      this.launchCode = this.$route.query?.launchCode;
      this.linkTerminal = this.$route.query.a;
      if (!activityNo && (!this.utmSource && !this.launchCode)) {
        return this.$toast({ message: "URL缺少参数" });
      }
      this.comefrom = comefrom || '';
      // this.isInMiniApp = await this.isMiniProgram()
      this.activityNo = activityNo;
      if (window.blackbox) {
        this.blackbox = window.blackbox
      }
       const poi = this.$route.query?.poi;
       if (this.$route.query?.poi || window.location.href.includes('poi')) {
         this.poi = true
       } else {
         this.poi = false
       }
      if (poi && poi !== "''") {
        if (poi.indexOf(',') !== -1) {
          const poiList = poi.split(',')
          this.location.longitude = poiList[0].toString()
          this.location.latitude = poiList[1].toString()
          this.citycode = poiList[2]
          this.shopCode = poiList[3]
        }
      }
      if (this.$route.query?.u_t) {
        this.token = this.$route.query?.u_t
      } else {
        this.token = ''
      }
      // gdt('track', 'VIEW_CONTENT', {'activityNo': this.activityNo});//浏览内容，这写页面加载的地方。
      try {
        if (this.$route.query?.u_t) {
          this.token = this.$route.query?.u_t
        } else {
          this.token = ''
        }
        const mmm = this.$route.query.mmm;
        if (Number(this.linkTerminal) === 3 || Number(this.linkTerminal) === 4) {
          if (mmm && mmm.includes("OL")) {
            this.mobile = mmm.replace('OL', '');
          }
        }
        this.isLoading = true;
        this.$toast.loading({ message: "加载中...", forbidClick: true, duration: 100 });
        this.marketingShareH5ActRequest();
        await this.marketingGetH5ActivityRequest(true);
        this.isLoading = false;
      } catch (err) {
        this.isLoading = false;
      }
    },

    // 获取券记录
    async getCouponRecordList () {
      const res = await getCouponRecord({
         activityNo: this.activityNo,
         memberId: this.memberId,
         couponShowName: this.couponName
        })
      if (res.code == 200 && res.data !== null) {
        this.couponRecordList = res.data
      }
    },

    async marketingShareH5ActRequest() {
      const res = await marketingShareH5Act({ activityNo: this.activityNo });
      if (res.code === 200) {
        if (res.busCode === "1") {
          this.shareData = res.data;
        } else {
          this.$toast({ message: res.busMessage });
        }
      } else {
        this.$toast({ message: res.message });
      }
    },

    openEnvelopeEvent () {
      if ((this.phone === '' || this.phone == null) && Number(this.linkTerminal) !== 2 && Number(this.linkTerminal) !== 4) {
        this.toPage('packages/common/login/index')
      } else if ((Number(this.linkTerminal) !== 2) && (this.phone === '' || this.phone == null) && (this.smsCode === '' || this.smsCode == null)) {
         this.$toast({ message: "请先登录后领取" });
      }
      else {
        if (Number(this.linkTerminal) === 2 || Number(this.linkTerminal) === 4) {
          this.handleSubmitAction()
        } else {
          this.handleRecieveAction()
        }
      }
    },
    changeImg() {
      if (this.activityData.receivingPublicityImg && this.activityData.receivingPublicityImg.url) {
        this.openEnvelope = true
        this.btnDisable = true
        setTimeout(()=> {
          this.closeEnvelope = true
          this.btnDisable = false
        },2000)
      } else {
        this.closeEnvelope = true
        this.btnDisable = false
      }
    },

    afterCoupon () {
      this.receiveContent = '啊哦～'
      this.couponName = '空空如也' // 失败的文案
      this.closeEnvelope = true
      this.btnDisable = false
    },
    getShopMdCode () {
      let shopMdCode = null;
      const poi = this.$route.query.poi || null
      if (poi && poi !== "''") {
        if (poi.indexOf(',') !== -1) {
          const poiList = poi.split(',')
          shopMdCode = poiList?.[3]
        }
      } else if (isCottiApp()) {
        shopMdCode = this.$route.query.shopMdCode || null
      } 
      return shopMdCode
    },

    // 详情
    async marketingGetH5ActivityRequest(isInit) {
      try {
        const res = await marketingGetH5Activity({
        activityNo: this.activityNo,
        openid: this.openId,
        mobile: this.phone || this.mobile,
        linkTerminal: Number(this.linkTerminal),
        launchCode: this.launchCode,
        channelType: this.channelType,
        utmSource: this.utmSource,
        shopMdCode: this.getShopMdCode(),
      });
      if (res.code === 200) {
        try {
          document.title = res.data.title;
        } catch (e) {
          console.log(e);
        }
        if (Number(this.linkTerminal) === 4) {
          try {
            AlipayJSBridge.call('setTitle', { title: res.data.title });
          } catch(e) {
            console.log(e)
          }
        }

        if (Number(this.linkTerminal) === 3) {
          try {
            var data = `{"title":"${res.data.title}"}`;
            TitleChange.postMessage(data);
          } catch(e) {
            console.log(e)
          }
        }
        this.unReceiveCoupon = res.data?.unReceiveCoupon
        if(res.data?.surroundingShopResult) {
          this.enableStatus = res.data.surroundingShopResult?.enableStatus
        }
        if (res.busCode === "1") {
          this.loading = false
          //通过判断 扫码之后的状态 37:QRCODE_INVALID: 二维码已失效，请重新扫码  38: QRCODE_ONLY 抱歉，活动仅限扫码参与' 显示
          // 27\39 门店不支持活动
          // res.data.status = 27
          if (res.data.status === 27 || res.data.status === 37 || res.data.status === 38 ) {
            this.showScanQrCodeStatus(res.data.status)
            return;
          }

          this.couponList = []
          if (res.data?.randomPrize) {
            this.randomPrize = res.data.randomPrize
          }
          if (res.data?.frontContentShowResult && res.data.status !== 9001) {
            this.frontContentShowResult = res.data.frontContentShowResult
          }
          this.couponName = res.data?.prizeName || res.data?.couponName || this.couponName
          if (res.data?.prizeCouponList) {
            this.prizeCouponList = res.data.prizeCouponList
            this.afterCoupon()
            this.couponList = []
            this.prizeCouponList.forEach((item, index) => {
              this.couponList.push(item.couponNo)
              })
          }
          this.memberId = res.data?.memberId || this.memberId; 
          this.activityData = res.data;
          this.phone = res.data?.mobile || this.phone;
          if (this.enableStatus == 1 && (Number(this.linkTerminal) === 2 || Number(this.linkTerminal) === 4) && this.unReceiveCoupon) {
            this.getAmap()
          } else if(this.enableStatus == 1 && this.unReceiveCoupon) {
            this.getLocation()
          }
          if (res.data.status === 1) {
            console.log("请求成功");
          }
          if (res.data.status === 2 || res.data.status === 3 || res.data.status === 4 || res.data.status === 6 || res.data.status === 7 || res.data.status === 9 || res.data.status === 10 || res.data.status === 20 || res.data.status === 22 || res.data.status === 26 || res.data.status >= 28) {
            this.isReceived = true
          }
          if (res.data.status == 9001) {
            this.isReceived = false
            this.$toast({ message: '当前门店暂不支持活动' });
          } else if (res.data.status === 5 || res.data.status === 25) {
            this.activityLost = true
          } else if (res.data.status === 8) {
            if (this.frontContentShowResult && this.frontContentShowResult.contentShowAfter !== null ) {
              this.isReceived = true
            } 
          } else if (res.data.status === 24) {
            this.isReceived = true
            if (this.isInMiniApp) {
              this.twoBtnModeTitle = '您已参与过当前系列活动 \n 感谢您对 Cotti 的关注'
              this.twoBtnModelShow = true
              this.twoBtnModeBtnStr[0] = '我知道了'
              this.twoBtnModeBtnStr[1] = '去喝一杯'
            } else {
              this.modelTitle = "您已参与过当前系列活动 \n 感谢您对 Cotti 的关注"
              this.modelBtnStr = '我知道了'
              this.modelShow = true
            }
          } else if (res.data.status === 7 || res.data.status === 6) {
            this.isReceived = false
            this.noReceived = true
          }
          if (isInit) {
            const isHasJumpLink = !!this.activityData?.receiveRewardComponent?.jumpLink
            this.h5CouponLandingPageView({
              activity_id: this.activityNo,
              wx_openid: this.openId,
              phone_number: this.activityData.mobile,
              is_received_new: this.isReceived ? "是" : "否",
              is_config_href_url_new: isHasJumpLink ? "是" : "否",
              is_free_order: this.activityData?.freeOrderActivity ? "是" : "否"
            });
          }
          this.handleShareAction();

        } else {
          this.loading = false
          this.activityLost = true
          this.$toast({ message: res.busMessage });
        }
        if (!this.activityData?.receiveRewardComponent?.jumpLink?.includes("http")) {
          if (this.isWeixinPlatform) {
            if (!this.isInMiniApp) {
              this.goApplet = true;
              this.appletUrl = this.activityData?.receiveRewardComponent?.jumpLink;
            }
          }
        }
      } else if (res.code === 429) {
        this.$toast({ message: "前方活动火爆，请重试!" });
      } else {
        this.$toast({ message: res.message });
      }
      } catch (err) {
        this.isErr = true
      }
      this.getAdButton(this.frontContentShowResult?.fixedPositionParam?.positionCode)
      if (this.activityData.participationDetails == 1) {
        this.getCouponRecordList()
      }
    },

    //通过判断 扫码之后的状态 37:QRCODE_ONLY 抱歉，活动仅限扫码参与' 显示   38: QRCODE_INVALID: 二维码已失效，请重新扫码
    showScanQrCodeStatus(status) {
      this.scanQrCodeStatusCode = status
      if (status === 27) {
        this.scanQrCodeStatus = 'CHOOSE_SHOP';
      } else if (status === 37) {
        this.scanQrCodeStatus = 'QRCODE_ONLY';
      } else if (status === 38) {
        this.scanQrCodeStatus = 'QRCODE_INVALID';
      } else if (status === 39) {
        this.scanQrCodeStatus = 'SHOP_INVALID';
      }
    },

    toPrivacy () {
      this.$router.push({path: '/privacy'})
    },

    toService () {
       this.$router.push({path: '/service'})
    },

    isAgree () {
      if (this.agreeFlag) {
        this.agree = ''
      }
      this.agreeFlag = true
    },

    changeAgree () {
      this.agreeFlag = false

    },
    showOffwork(e) {
      this.customerServiceCase = e
      this.$refs.offwork.show()
    },

    toPage(url) {
      if (this.isInMiniApp) {
        wx.miniProgram.navigateTo({
        url: `/${url}`,
      })
      } else if (Number(this.linkTerminal) === 3) {
        try {
            const data = ''
            NavigationLogin.postMessage(data)
          } catch (e) {
            console.warn('NavigationLogin is error')
            console.warn(e)
          }
      }
    },

    async marketingReceiveRewardH5Request(telephone) {
      try {
        let res = await window?._fmOpt?.getinfo()
        if(res) {
          this.blackbox = res
        }
      } catch(e) {
        if (window.blackbox) {
          this.blackbox = window.blackbox
        }
      }
      this.$toast.loading({ message: "加载中...", forbidClick: true, duration: 100 });
      marketingReceiveRewardH5({
        activityNo: this.activityNo,
        mobile: telephone,
        comeFrom: this.comefrom,
        launchCode: this.launchCode,
        channelType: this.channelType,
        utmSource: this.utmSource,
        openid: this.openId,
        blackBox: this.blackbox,
        shopMdCode: this.getShopMdCode(),
        extendJson: this.activityData?.extendJson || '',
      }).then((res) => {
        if (res.code === 200) {
          if (res.busCode === "1") {
            if (res.data.status === 9001) {
              this.isTick = true;
              this.$toast({ message: '当前门店暂不支持活动' });
              return;
            }
            if (res.data.status === 39) {
              this.isSupport = false;
              return;
            }
            //通过判断 扫码之后的状态 37:QRCODE_INVALID: 二维码已失效，请重新扫码  38: QRCODE_ONLY 抱歉，活动仅限扫码参与' 显示
            if (res.data.status === 37 || res.data.status === 38 ) {
              this.showScanQrCodeStatus(res.data.status);
              return;
            }

            this.unReceiveCoupon = res.data?.unReceiveCoupon
            if (res.data.buttonImg && res.data.buttonImg.url) {
              this.activityData.receiveRewardComponent.buttonImgs[1] = res.data.buttonImg
            } else {
              this.activityData.receiveRewardComponent.buttonImgs = [this.activityData.receiveRewardComponent.buttonImgs[0]]
            }
            // this.enableStatus = res.data.surroundingShopResult?.enableStatus
             if (res.data.frontContentShowResult) {
              this.frontContentShowResult = res.data.frontContentShowResult
              }
              this.couponName = res.data?.prizeName || res.data?.couponName || this.couponName
              this.receiveContent = res.data?.receiveContent || this.receiveContent
              this.couponList = []
              if (res.data.prizeCouponResultList) {
                this.prizeCouponList = res.data.prizeCouponResultList
                this.couponList = []
                this.prizeCouponList.forEach((item, index) => {
                  this.couponList.push(item.couponNo)
                })
              }
              if (this.enableStatus == 1 && (Number(this.linkTerminal) === 2 || Number(this.linkTerminal) === 4)) {
                 this.getAmap()
              } else if(this.enableStatus == 1) {
                this.getLocation()
              }
              // 当res.data.memberId存在时才进行赋值
              this.memberId = res.data?.memberId || this.memberId
              if (res.data.status === 1) {
              this.changeImg()
              this.unReceiveCoupon = true
              this.claimCouponClick({
                receive_result_new: "成功",
                is_member_new: res.data?.memberId ? "是" : "否",
                activity_id: this.activityNo,
                receive_result_status:res.data?.status,
                is_free_order: this.activityData?.freeOrderActivity ? "是" : "否"
              });
              this.isReceived = true;
              // }
              _ks_trace.push({event: 'form', convertId: 564821, cb: function(){ console.log('Your callback function here!')}}) //快手领券埋点
              // gdt('track', 'CLAIM_OFFER', {'activityNo': this.activityNo});// 领取卡券， 这写在点击领券的地方。
              if (this.activityData.participationDetails == 1) {
                this.getCouponRecordList()
              }
            } else {
              if (res.data.status !== 0) {
                this.afterCoupon()
              }
              this.claimCouponClick({
                receive_result_new: "失败",
                is_member_new: res.data?.memberId ? "是" : "否",
                activity_id: this.activityNo,
                receive_result_status:res.data.status,
                is_free_order: this.activityData?.freeOrderActivity ? "是" : "否"
              });
              if (res.data.status === 0) {
                this.isReceived = false
                this.$toast({ message: res.data.message });
              } else if (res.data.status === 10) {
                this.isReceived = true
              } else if (res.data.status === 8) {
                if (this.frontContentShowResult && this.frontContentShowResult.contentShowAfter !== null ) {
                  this.isReceived = true
                }
              } else if (res.data.status === 9) {
                this.isReceived = true
              } else if (
                res.data.status === 16 ||
                res.data.status === 18 ||
                res.data.status === 19
              ) {
                this.ispopup = true;
              } else if(res.data.status === 40) {
                this.isReceived = true
                this.$toast({ message: '今日券已领完' });
              } else if (res.data.status === 11) {
                this.$toast({ message: res.data.message });
              } else if (res.data.status === 2 || res.data.status === 4 || res.data.status === 3 || res.data.status === 31 || res.data.status >= 28) {
                this.isReceived = true
                if (res.data.status === 4 || res.data.status === 3) {
                  this.activityData.status = res.data.status
                }
                // this.activityNotStart = true
              } else if (
                res.data.status === 5 ||
                res.data.status === 15 ||
                res.data.status === 17 ||
                res.data.status === 22 ||
                res.data.status === 23
              ) {
                this.modelTitle = res.data.message
                this.modelBtnStr = '我知道了'
                this.modelShow = true
              }
              else if(
                res.data.status === 6 ||
                res.data.status === 7) {
                  this.isReceived = false
                  this.noReceived = true
                //   this.modelTitle = res.data.message
                // this.modelBtnStr = '我知道了'
                // this.modelShow = true
              } else if (res.data.status === 21) {
                this.groupGiftTitle = res.data.message;
                this.isGroupGift = true;
              } else if (res.data.status === 24) {
                this.isReceived = true
                if (this.isInMiniApp) {
                  this.twoBtnModeTitle = '您已参与过当前系列活动 \n 感谢您对 Cotti 的关注'
                  this.twoBtnModeBtnStr[0] = '我知道了'
                  this.twoBtnModeBtnStr[1] = '去喝一杯'
                  this.twoBtnModelShow = true
                } else {
                  this.modelTitle = "您已参与过当前系列活动 \n 感谢您对 Cotti 的关注"
                  this.modelBtnStr = '我知道了'
                  this.modelShow = true
                }
              } else if (res.data.status === -110) {
                this.toPage('packages/common/login/index')
              } else {
                this.$toast({ message: res.data.message });
                this.isReceived = true
                // this.isReceivedInitial = true
              }
            }

          } else {
            this.claimCouponClick({
              receive_result_new: "失败",
              is_member_new: res.data?.memberId ? "是" : "否",
              activity_id: this.activityNo,
              receive_result_status:res.data?.status,
              is_free_order: this.activityData?.freeOrderActivity ? "是" : "否"
            });
            this.$toast({ message: res.busMessage });
          }
        } else {
          this.claimCouponClick({
            receive_result_new: "失败",
            is_member_new: res.data?.memberId ? "是" : "否",
            activity_id: this.activityNo,
            receive_result_status:res.data?.status,
            is_free_order: this.activityData?.freeOrderActivity ? "是" : "否"
          });
          this.$toast({ message: res.message });
        }
        this.isTick = true;
      }).catch(err => {
        this.$toast({ message: "前方活动火爆，请重试!" });
        this.isTick = true;
        return
        // this.$toast({
        //   message: err.message
        // })
      })
    },
    h5CouponLandingPageView(data) {
       // 关闭埋点 加载过慢
      this.$sensors.track("h5_CouponLandingPage_view", data);
      // if (data.memberId) {
      //   this.$sensors.login(data.memberId);
      // }
    },

    // 此用户是否为舌尖会员（是/否）
    claimCouponClick(data) {
       // 关闭埋点 加载过慢
      this.$sensors.track("claimCoupon_click", data);
      // if (data.memberId) {
      //   this.$sensors.login(data.memberId);
      // }
    },

    couponClaimedClick(data) {
       // 关闭埋点 加载过慢
      this.$sensors.track("couponClaimed_click", data);
    },

    handleShareAction() {
      if (this.activityData) {
        wx.showOptionMenu();
        if (!this.activityData.share) {
          wx.hideOptionMenu();
        }
        wx.updateAppMessageShareData({
          title: this.shareData.shareTitle,
          desc: this.shareData.shareDesc,
          link: window.location.href,
          imgUrl: this.shareData.shareImg,
          success: function () {
            console.log("设置朋友成功");
          },
        });
        wx.updateTimelineShareData({
          title: this.shareData.shareTitle,
          link: window.location.href,
          imgUrl: this.shareData.shareImg,
          success: function () {
            console.log("设置朋友圈成功");
          },
        });
      }
    },
    async collectingCoupon() {
      try {
        let res = await window?._fmOpt?.getinfo()
        if(res) {
          this.blackbox = res
        }
      } catch(e) {
        if (window.blackbox) {
          this.blackbox = window.blackbox
        }
      }
      getCustomerCheckSmsCodeH5({
        mobile: this.mobile,
        smsCode: this.smsCode,
        activityNo: this.activityNo,
        comeFrom: this.comefrom,
        utmSource: this.utmSource,
        openid: this.openId,
        launchCode: this.launchCode,
        channelType:this.channelType,
        blackBox: this.blackbox,
        shopMdCode: this.getShopMdCode(),
        extendJson: this.activityData?.extendJson || '',
      }).then((res) => {
        if (res.code === 200) {
          if (res.busCode === "1") {
            //通过判断 扫码之后的状态 37:QRCODE_INVALID: 二维码已失效，请重新扫码  38: QRCODE_ONLY 抱歉，活动仅限扫码参与' 显示
            if (res.data.status === 37 || res.data.status === 38 ) {
              this.showScanQrCodeStatus(res.data.status);
              return;
            }

            this.unReceiveCoupon = res.data.unReceiveCoupon
            if (res.data.buttonImg && res.data.buttonImg.url) {
              this.activityData.receiveRewardComponent.buttonImgs[1] = res.data.buttonImg
            } else {
              this.activityData.receiveRewardComponent.buttonImgs = [this.activityData.receiveRewardComponent.buttonImgs[0]]
            }
             if (res.data.frontContentShowResult) {
              this.frontContentShowResult = res.data.frontContentShowResult
              this.unReceiveCoupon = res.data.unReceiveCoupon
              }
              this.couponList = []
              if (res.data.prizeCouponResultList) {
                this.prizeCouponList = res.data.prizeCouponResultList
                this.couponList = []
                this.prizeCouponList.forEach((item, index) => {
                  this.couponList.push(item.couponNo)
                })
              }
              this.memberId = res.data?.memberId || this.memberId 
              this.couponName = res.data?.prizeName || res.data?.couponName || this.couponName
              this.receiveContent= res.data?.receiveContent || this.receiveContent
              if (this.enableStatus == 1 && (Number(this.linkTerminal) === 2 || Number(this.linkTerminal) === 4)) {
                 this.getAmap()
                //  this.getLocation()
              } else if(this.enableStatus == 1) {
                this.getLocation()
              }
              if (res.data.status === 1) {
              this.unReceiveCoupon = true
              this.changeImg()
              this.claimCouponClick({
                receive_result_new: "成功",
                is_member_new: res.data?.memberId ? "是" : "否",
                activity_id: this.activityNo,
                receive_result_status:res.data?.status,
                is_free_order: this.activityData?.freeOrderActivity ? "是" : "否"
              });
              this.isReceived = true;
              _ks_trace.push({event: 'wechat_copy', convertId: 564516, cb: function(){    console.log('Your callback function here!')}}) //快手领券埋点
              // gdt('track', 'CLAIM_OFFER', {'activityNo': this.activityNo});// 领取卡券， 这写在点击领券的地方。
              if (this.activityData.participationDetails == 1) {
                this.getCouponRecordList()
              }
            } else {
              if (res.data.status !== 0) {
                this.afterCoupon()
              }
              this.claimCouponClick({
                receive_result_new: "失败",
                is_member_new: res.data?.memberId ? "是" : "否",
                activity_id: this.activityNo,
                receive_result_status:res.data?.status,
                is_free_order: this.activityData?.freeOrderActivity ? "是" : "否"
              });
              if (res.data.status === 0) {
                this.$toast({ message: res.data.message });
              } else if (res.data.status === 10) {
                this.isReceived = true
              } else if (res.data.status === 8) {
                if (this.frontContentShowResult && this.frontContentShowResult.contentShowAfter !== null ) {
                  this.isReceived = true
                }
                //  this.$toast({ message: res.data.message });
              } else if (res.data.status === 9) {
                this.isReceived = true
              } else if (
                res.data.status === 16 ||
                res.data.status === 18 ||
                res.data.status === 19
              ) {
                this.ispopup = true;
              } else if(res.data.status === 40) {
                this.isReceived = true
                this.$toast({ message: '今日券已领完' });
              } else if (res.data.status === 11) {
               this.$toast({ message: res.data.message });
              } else if (res.data.status === 2 || res.data.status === 4 || res.data.status === 3 || res.data.status >= 28 ) {
                this.isReceived = true
                if (res.data.status === 4 || res.data.status === 3) {
                  this.activityData.status = res.data.status
                }
              } else if (
                res.data.status === 5 ||
                res.data.status === 15 ||
                res.data.status === 17 ||
                res.data.status === 22 ||
                res.data.status === 23
              ) {
                this.modelTitle = res.data.message
                this.modelBtnStr = '我知道了'
                this.modelShow = true
              } else if(
                res.data.status === 6 ||
                res.data.status === 7) {
                  this.isReceived = false
                  this.noReceived = true
                //   this.modelTitle = res.data.message
                // this.modelBtnStr = '我知道了'
                // this.modelShow = true
              } else if (res.data.status === 21) {
                this.groupGiftTitle = res.data.message;
                this.isGroupGift = true;
              } else if (res.data.status === 24) {
                this.isReceived = true
                if (this.isInMiniApp) {
                  this.twoBtnModeTitle = '您已参与过当前系列活动 \n 感谢您对 Cotti 的关注'
                  this.twoBtnModeBtnStr[0] = '我知道了'
                  this.twoBtnModeBtnStr[1] = '去喝一杯'
                  this.twoBtnModelShow = true
                } else {
                  this.modelTitle = "您已参与过当前系列活动 \n 感谢您对 Cotti 的关注"
                  this.modelBtnStr = '我知道了'
                  this.modelShow = true
                }
              } else {
                this.$toast({ message: res.data.message });
                this.isReceived = true
                // this.isReceivedInitial = true
              }
            }

          } else {
            this.claimCouponClick({
              receive_result_new: "失败",
              is_member_new: res.data.memberId ? "是" : "否",
              activity_id: this.activityNo,
              receive_result_status:res.data.status,
              is_free_order: this.activityData?.freeOrderActivity ? "是" : "否"
            });
            this.$toast({ message: res.busMessage });
          }
        } else {
          this.claimCouponClick({
            receive_result_new: "失败",
            is_member_new: res.data.memberId ? "是" : "否",
            activity_id: this.activityNo,
            receive_result_status:res.data.status,
            is_free_order: this.activityData?.freeOrderActivity ? "是" : "否"
          });
          this.$toast({ message: res.message });
        }
      })
    },

    handleSubmitAction() {
      if (!this.mobile || !this.mobile.trim()) {
        return this.$toast({ message: "手机号输入不能为空" });
      }
      if (!isPhone(this.mobile)) {
        return this.$toast({ message: "请输入正确的手机号" });
      }
      if (!this.smsCode || !this.smsCode.trim()) {
        return this.$toast({ message: "验证码不能为空" });
      }

      const reg = new RegExp('[0-9]{' + this.smsCodeMax + '}')
      // if (!reg.test(this.smsCode)) {
      //   return this.$toast({ message: "请输入正确的验证码" });
      // }
      if (!this.agreeFlag) {
        return this.$toast({ message: "请阅读并勾选《用户协议》和《隐私政策》", duration: 4000 });
      }
      this.collectingCoupon();
    },
    handleRecieveAction() {
      if (this.isTick) {
        this.isTick = false;
        this.marketingReceiveRewardH5Request(this.phone);
      }
    },
    handleJumpAction(jumpLink, jumpType) {
      if (jumpLink) {
        this.couponClaimedClick({
          is_config_href_url_new: "是",
          activity_id: this.activityNo,
        });
        // 领券后按钮
        if (jumpLink?.includes("http")) {
          window.location.href = jumpLink;
        } else {
          if (this.isInMiniApp) {
            // let pathList = [
            //   "pages/index/index",
            //   "pages/purchase/index",
            //   "pages/coupon-store/index",
            //   "pages/order/index",
            //   "pages/mine/index"
            // ];
            if (jumpLink.includes('pages/') && !jumpLink.includes('?')) {
              wx.miniProgram.switchTab({
                url: `/${jumpLink}`,
                success: function (res) {
                  console.log('success res=', res)
                },
                fail: function (res) {
                  console.log('fail res=', res)
                }
              });
            } else {
              wx.miniProgram.navigateTo({
                url: `/${jumpLink}`,
                success: function (res) {
                  console.log('success res=', res)
                },
                fail: function (res) {
                  console.log('fail res=', res)
                }
              });
            }
          } else if (Number(this.linkTerminal) === 3) {
              const data = `{"path":"${jumpLink}"}`
              CottiNavigation.postMessage(data)
          }  else if (this.linkTerminal == '4' || this.linkTerminal === 4) {
             if (jumpLink.includes('pages/') && !jumpLink.includes('?')) {
              my.switchTab({
                url: `/${jumpLink}`,
                success: function (res) {
                  console.log(res, '成功');
                },
                fail: function (err) {
                  console.log(err);
                }
              });
            } else {
              my.navigateTo({
                url: `/${jumpLink}`,
                success: function (res) {
                  console.log('success res=', res)
                },
                fail: function (res) {
                  console.log('fail res=', res)
                }
              });
            }
          } else {
              if (jumpType == 1) {
                this.goApp = true
                this.appletUrl = jumpLink;
                this.openApp(this.appletUrl)
              } else if (jumpType == 2) {
                this.goApplet = true;
                this.appletUrl = jumpLink;
                this.openApplet(this.appletUrl)
              } else if (jumpLink == 3) {
                this.appletUrl = jumpLink
                this.onAli(this.appletUrl)
              }
            }
        }
      } else {
        this.couponClaimedClick({
          is_config_href_url_new: "否",
          activity_id: this.activityNo,
          is_free_order: this.activityData?.freeOrderActivity ? "是" : "否"
        });
      }
    },
    // 入群有礼弹窗点击事件
    groupGiftClick() {
      if (this.isInMiniApp) {
        wx.miniProgram.switchTab({
          url: 'pages/index/index'
        });
      } else {
        this.isGroupGift = false;
      }
    },
    async handleSendSmsCode() {
      if (!this.mobile || !this.mobile.trim()) {
        return this.$toast({ message: "手机号输入不能为空" });
      }
      if (!isPhone(this.mobile)) {
        return this.$toast({
          message: "请输入正确的手机号，否则无法接收验证码",
        });
      }
      try {
        let res = await window?._fmOpt?.getinfo()
        if(res) {
          this.blackbox = res
        }
      } catch(e) {
        if (window.blackbox) {
          this.blackbox = window.blackbox
        }
      }
      getCustomerSmsCodeOL({ mobile: this.mobile, blackBox: this.blackbox }).then((res) => {
        if (res.code === 200) {
          if (res.busCode === "1") {
            this.$toast({ message: "验证码已发送" });
            const { smsConfigResult, codeLength } = res.data;
            this.smsCodeMax = codeLength || 6
            if (!!smsConfigResult) {
              this.codeTypeData = {
                code: smsConfigResult?.code,
                title: smsConfigResult?.title,
                content: smsConfigResult?.content?.replace('AAA', this.mobile),
              }
            }
            this.isSmsSend = true;
            this.handleCountDown();
          } else {
            this.$toast({ message: res.busMessage });
          }
        } else {
          this.$toast({ message: res.message });
        }
      });
    },
    handleCountDown() {
      this.timer = setInterval(() => {
        this.sendBtnText = `<span>${this.counter}s</span>后重新获取`;
        this.counter--;
        if (this.counter < 0) {
          this.handleSmsReset();
        }
      }, 1000);
    },
    handleSmsReset() {
      this.isSmsSend = false;
      this.sendBtnText = "获取验证码";
      if (this.timer) {
        clearInterval(this.timer);
        this.counter = 60;
        this.timer = null;
      }
    },
    haveDecimal(str) {
      return String(str).indexOf(".") + 1;
    },
    // 判断是否是微信浏览器还是小程序环境
    isMiniProgram() {
      // wx.miniProgram.getEnv是异步，所以封装在Promise中
      return new Promise((resolve) => {
        if (this.isWeixinPlatform) {
          return wx.miniProgram.getEnv((res) => {
            if (res.miniprogram) {
              resolve(true);
            } else {
              resolve(false);
            }
          });
        }
        resolve(false);
      });
    },
    popup_del() {
      this.ispopup = false;
    },
    goCommunity() {
      this.$router.push({
        path: "/onlineqrcode",
        query: {
          codebg: "cotti-my-socialGroup-bg-banner-mp",
          codeqrcode: "cotti-my-socialGroup-banner-mp",
        },
      });
      this.ispopup = false;
    },
    leftClick() {
      this.twoBtnModelShow = false
    },
    rightClick() {
      if (this.isInMiniApp) {
        wx.miniProgram.switchTab({
          url: '/pages/purchase/index'
        });
      }
    },
    doOpenRule() {
      this.openRule = true
      this.stopScroll()
    },
    doCloseRule() {
      this.openRule = false
      this.canScroll()
    },
    closeModelShow() {
      this.modelShow = false
    },
    closeModelSuccessShow() {
      this.modelSuccessShow = false
    },
    // 广告位拉起app 小程序
    goToUrl() {
      if (Number(this.linkTerminal) === 3) {
        this.handleJumpAction(this.frontContentShowResult?.fixedPositionParam?.appUrl, '')
      } else if (this.isInMiniApp) {
         this.handleJumpAction(this.frontContentShowResult?.fixedPositionParam?.wxUrl, '')
      } else if (Number(this.linkTerminal) === 4) {
        this.handleJumpAction(this.frontContentShowResult?.fixedPositionParam?.aliUrl, '')
      }
      else {
        this.handleJumpAction(this.frontContentShowResult?.fixedPositionParam?.h5Url, this.frontContentShowResult?.fixedPositionParam?.h5UrlJumpType)
      }
    },
    // 跳转小程序
    openApplet(appletUrl) {
      try {
        const path = appletUrl.split('?')[0]
        const query = appletUrl.split('?')[1]
        const params = JSON.stringify({ path: appletUrl })
        getWeChatScheme({ path, query }).then(res => {
          if (res.data.scheme) {
            location.href = res.data.scheme;
          } else {
            this.$toast({ message: "打开小程序失败，请确认已安装微信" });
          }
        })
      }catch (e) {
        this.$toast({ message: "打开小程序失败，请确认已安装微信" });
      }
    },
     // 跳转app
    openApp(appletUrl) {
      const path = appletUrl.split('?')[0]
      const query = appletUrl.split('?')[1]
      const params = JSON.stringify({ path: appletUrl })
      launchApp('PAGES', Base64.encodeURI(params), true)
    },
    // 跳转支付宝小程序
    onAli(appletUrl) {
      let params =`alipays://platformapi/startapp?appId=2021004123660926&page=/${appletUrl}`
      window.location.href = `https://ds.alipay.com/?scheme=${params}`
    },
    getStyle(item) {
      const url = item?.buttonImgExternal?.url || ''
      const config = {
        'left': item && item.positionX / 100.0 + 'rem',
        'top': item && item.positionY / 100.0 + 'rem',
      }
      if (url) {
        config['background-image'] = `url(${url})`
      }
      return config
    }
  }
};
</script>

<style lang="scss" scoped >
$button-bg-color: #A52337;
$text-color: #D77C43;
$tip-bg-color: #CF4744;
.bottom-height {
  height: 68px;
  width: 100%;
}

.unsupport-wrapper {
  width: 100%;
  background: #FFFFFF;
  border-radius: 12px;
  text-align: center;
  font-weight: 400;
  font-size: 14px;
  color: #333333;
  line-height: 20px;
  padding: 16px 0;
  .unsupport-desc {
    font-weight: 500;
    font-size: 26px;
    color: #2A2A2A;
    line-height: 40px;
    margin: 8px 0;
  }
}

.scroll-hide {
  width: 100%;
  height: 100%;
  -webkit-overflow-scrolling: touch;
  overflow-y: auto;
  overflow-x: hidden;
  position: fixed;
  position: -ms-device-fixed;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  background: var(--background-color);
}

.ticket {
  height: 100%;
  position: relative;

  .ctn-ad {
    img {
      border-radius: 0 0 24px 24px;
    }
  }
  .cnt-button {
    outline: none;
    background: rgba(0, 0, 0, 0);
    border: none;
    font-size: 0;
    padding: 0;
    margin: 0;
    

    &.radius {
      border-radius: 8px;
      overflow: hidden;
    }
  }

  .ticket-bg-img {
    width: 100%;
    position: absolute;
    top: 0;
  }
   .envelope-img {
    position:absolute;
    top: 0;
    z-index:999;
    width: 100%;
  }
  .coupon {
    z-index: 9999;
    position: absolute;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    // max-width: 130px;
    // left: 25%;
  }
  .coupon-name {
    width: 360px;
    height: 56px;
    font-size: 34px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: var(--text-base-color);
    line-height: 56px;
    text-shadow: 0px 4px 8px rgba(249,181,87,0.1);
    text-align: center;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    // padding-top: 16px;

  }
   .coupon-text {
    width: 360px;
    height: 34px;
    font-size: 24px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: var(--text-base-color);
    line-height: 34px;
    text-shadow: 0px 6px 8px rgba(238,181,103,0.2);
    // margin-top: -480px;
    text-align: center;
    margin-top: -48px;
    padding-bottom: 16px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }


  .ticket-rule {
    position: absolute;
    z-index: 1001;
    top: 32px;
    right: 32px;
    width: 164px;
    height: 56px;
    border-radius: 27px;
    background: rgba(55, 55, 55, 0.4);
    font-weight: 500;
    color: #fff;
    line-height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 24px;

    .rule-img {
      width: 28px;
      margin-right: 10px;
    }
  }

  .ticket-single {
    box-sizing: border-box;
    background-size: cover;
    margin-bottom: 15px;
    left: 64px;
    top: 760px;
    background: rgba(255, 255, 255, 0.9);
    border-radius: 16px;
    padding: 22px 22px 16px;

    .single-content {
      height: 176px;
      width: 658px;
      background-image: url(https://cdn-product-prod.cotticoffee.com/wechat/cotti/images/activity-single.png);
      background-size: 100% 100%;
      display: flex;

      .content-item {
        color: $text-color;
      }

      .content-item-price {
        display: flex;
        justify-content: center;
        align-items: center;
        font-weight: 500;
        font-size: 40px;
        width: 228px;
        flex-direction: column;
        padding-left: 18px;

        .price-unit {
          font-size: 28px;
          font-weight: 550;
          position: relative;
          top: 5px;
        }

        .price-num {
          font-size: 44px;
          line-height: 48px;
          font-weight: 600;
        }

        .price-name {
          font-size: 28px;
        }

        .name-num {
          font-size: 20px;
          font-weight: 400;
          color: $text-color;
          line-height: 28px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }

      .content-item-name {
        text-align: left;
        width: 290px;
        padding-left: 28px;
        display: flex;
        align-items: center;

        .name-text {
          font-size: 32px;
          font-weight: 500;
          color: $text-color;
          overflow: hidden;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          -ms-text-overflow: ellipsis;
          text-overflow: ellipsis;
        }
      }
      .content-item-type {
        position: relative;
        .type-name {
          position: absolute;
          top: 10px;
          right: -84px;
          color: #fff;
          width: 76px;
          font-size: 24px;
          font-weight: 500;
          text-align: center;
          font-family: PingFangSC-Medium, sans-serif;
          background-color: $tip-bg-color;
          padding: 10px;
          border-top-right-radius: 12px;
          border-bottom-left-radius: 12px;
        }
      }
    }
  }
  .ticket-multiple {
    box-sizing: border-box;
    margin-bottom: 15px;
    left: 64px;
    top: 250px;
    width: 702px;
    background: rgba(255, 255, 255, 0.9);
    border-radius: 16px;
    padding: 32px 24px;
    .multiple-header {
      height: 36px;
      font-size: 26px;
      font-weight: 500;
      color: #111;
      line-height: 36px;
      text-align: center;
      margin-bottom: 24px;
    }
    .multiple-main {
      display: flex;
      justify-content: space-between;
      flex-direction: row;
      flex-wrap: wrap;
      max-height: 300px;
      overflow-y: auto;
      .multiple-content {
        background-image: url('../../assets/ticket/multiple.png');
        background-size: 100% 100%;
        width: 316px;
        height: 116px;
        display: flex;
        margin-bottom: 24px;
        .content-item {
          color: $text-color;
        }
        .content-item-type {
          position: relative;
          .type-name {
            position: absolute;
            top: 10px;
            right: -84px;
            color: #fff;
            width: 76px;
            font-size: 24px;
            font-weight: 500;
            text-align: center;
          }
        }
        .content-item-price {
          display: flex;
          justify-content: center;
          align-items: center;
          font-weight: 500;
          width: 50%;
          padding-left: 6px;
          flex-direction: column;
          .price-unit {
            font-size: 22px;
            position: relative;
            top: 2px;
          }
          .price-unit-rmb {
            font-size: 24px;
            position: relative;
            top: 3px;
          }
          .price-num {
            font-size: 36px;
            line-height: 48px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          .name-num {
            height: 28px;
            font-size: 12px;
            color: $text-color;
            margin-bottom: 4px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            max-width: 130px;
          }
          .price-change-buy {
            font-size: 14px;
            font-weight: 500;
            width: 12px;
            display: inline-block;
            margin-left: 4px;
          }
        }
        .content-item-name {
          box-sizing: border-box;
          text-align: left;
          padding-left: 24px;
          padding-right: 18px;
          width: 48%;
          display: flex;
          align-items: center;
          .name-text {
            font-size: 26px;
            font-weight: 500;
            color: $text-color;
            overflow: hidden;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
          }
        }
      }
    }
  }
  .ticket-user {
    left: 64px;
    top: 950px;
    width: 702px;
    min-height: 300px;
    border-radius: 24px;
    background: rgba(255, 255, 255);
    box-sizing: border-box;
    padding: 32px 24px;
    margin-bottom: 24px;
    box-shadow: 0px 6px 16px 0px rgba(0,0,0,0.06);
    .user-wrapper {
      margin-bottom: 26px;
      .radio {
        padding: 18px 0 18px 0px;
        .text {
        height: 40px;
        line-height: 40px;
        font-size: 24px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: var(--title-color);
      }
      .img {
        width: 32px;
        height: 32px;
      }
      .click-text {
        color: var(--primary-color);
      }
      }
      ::v-deep .van-cell {
        padding: 18px 32px;
      }
      &.passwd-item {
        ::v-deep .van-cell {
          padding-right: 0;
        }
      }
      .van-field {
        background: #fff;
        border-radius: 8px;
        border: 1px solid var(--text-color);

        ::v-deep .van-field__control {
          font-size: 32px;
        }

        ::v-deep input::-webkit-input-placeholder {
          font-size: 28px;
        }
      }
      .button-warpper {
        min-width: 186px;
        padding: 0 20px;
        display: flex;
        flex: 1 1 auto;
        justify-content: center;
        position: relative;
        border-left: 1px solid #e5e5e5;
        .code-line {
          position: absolute;
          left: 0;
          top: 0;
          color: #e5e5e5;
        }
        .code-action {
          height: 32px;
          font-size: 28px;
          font-weight: 400;
          color: var(--text-base-color);
          line-height: 32px;
        }
        ::v-deep .code-action__disabled {
          height: 32px;
          font-size: 28px;
          font-weight: 400;
          color: var(--title-color);
          line-height: 32px;
          >span {
            padding-right: 6px;
            color: var(--text-base-color);
          }
        }
      }
    }
    .privacy {
      display:inline;
    }
    .captcha-notice {
      margin-bottom: 28px;
      font-size: 24px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: var(--text-color);
      line-height: 34px;
      text-align: justify;
      padding-top: 16px;
    }
    .user-action {
      width: 100%;
      margin-top: 14px;

      img {
        width: 100%;
      }
    }
  }
  .ticket-receive {
    left: 64px;
    top: 950px;
    width: 702px;
    background: rgba(255, 255, 255);
    border-radius: 24px;
    box-sizing: border-box;
    padding: 32px 24px;
    text-align: center;
    backdrop-filter: blur(2px);
    margin-bottom: 24px;
    box-shadow: 0px 6px 16px 0px rgba(0,0,0,0.06);
    .receive-title {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 40px;
      line-height: 40px;
      margin-bottom: 16px;
      .text {
        height: 28px;
        font-size: 28px;
        font-weight: 400;
        color: var(--coupon-toast-color);
        line-height: 28px;
        white-space: nowrap;
        text-align: center;
      }
    }
    .receive-phone {
      height: 80px;
      font-size: 52px;
      font-weight: 500;
      color: #2A2A2A;
      line-height: 80px;
      margin-bottom: 16px;
    }
     .received-phone {
        height: 28px;
        font-size: 28px;
        font-weight: 400;
        color: var(--coupon-toast-color);
        line-height: 28px;
        white-space: nowrap;
        text-align: center;
    }
    .receive-action {
      padding: 0 6px;
      img {
        width: 100%;
      }
    }
  }
  .shop-receive {
    margin-bottom: 24px;
    width: 702px;
    background: rgba(255, 255, 255, 1);
    border-radius: 24px;
    box-sizing: border-box;
    padding: 32px 24px;
    backdrop-filter: blur(2px);
    box-shadow: 0px 6px 16px 0px rgba(0,0,0,0.06);
    .activity-title {
      height: 44px;
      font-size: 32px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: var(--title-color);
      line-height: 44px;
      border-radius: 16px;
    }
    .max-receive {
      overflow: auto;
      background-color: #F5F5F5;
      border-radius: 16px;
      padding: 28px 24px 0 24px;
      overflow-x: hidden;
      margin-top: 32px;
    }
    .no-receive {
      overflow: auto;
      overflow-x: hidden;
      margin-bottom: 32px;
      .img {
        width: 160px;
        height: 160px;
        margin-left: 35%;
        margin-top: 32px;

      }
      .no-card {
        font-size: 24px;
        height: 36px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: var(--text-color);
        line-height: 36px;
        text-align: center;
        // margin-bottom: 32px;
      }
    }
    .activity-desc {
      height: 32px;
      font-size: 22px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #5E5E5E;
      line-height: 32px;
      margin: 12px 0 8px 0;
    }
    .shop-list {
      margin-top: 32px;
    }
  }
  .ticket-received {
    text-align: center;
    left: 64px;
    top: 65px;
    width: 702px;
    min-height: 300px;
    background: rgba(255, 255, 255);
    box-sizing: border-box;
    border-radius: 24px;
    padding: 32px 24px;
    margin-bottom: 24px;
    box-shadow: 0px 6px 16px 0px rgba(0,0,0,0.06);
    .received-title {
      height: 40px;
      font-size: 28px;
      font-weight: 500;
      color: var(--coupon-toast-color);
      line-height: 40px;
      margin-bottom: 16px;
    }
    .received-new-title {
      height: 56px;
      font-size: 40px;
      font-weight: 600;
      color: #2A2A2A;
      line-height: 56px;
      margin-bottom: 16px;
    }
    .received-hint {
      height: 28px;
      font-size: 28px;
      font-weight: 600;
      color: var(--coupon-toast-color);
      line-height: 28px;
    }
    .received-bag {
      height: 80px;
      font-size: 36px;
      font-weight: 600;
      color: var(--text-base-color);
      line-height: 80px;
      margin-bottom: 16px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .received-phone {
      height: 40px;
      font-size: 28px;
      font-weight: 500;
      color: var(--coupon-toast-color);
      line-height: 40px;
      margin-bottom: 32px;
    }
    .received-action {
      padding: 0 0px;
      img {
        width: 100%;
      }
    }
    .no-received {
      position: relative;
      font-size: 0;
      margin: 0 -24px -48px -24px;
    }
  }
}
.img_box {
  position: absolute;
  top: 0;
  height: 320px;
}

.box_ticket {
  position: absolute;
  top: 0px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  align-items: center;
  flex-direction: column;
  .publicity-picture {
    width: 702px;
    margin: 0 auto 32px;
    overflow: hidden;

    >img {
      width: 100%;
      height: 100%;
    }
  }
}
.error_bg{
  background: linear-gradient( 225deg, #FFFFFF 0%, #FFD5D3 100%);
}
.error_bg_tc {
  background: linear-gradient( 225deg, #FFFFFF 0%, #FBFFBE 100%);
}
.lost {
  display:flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 90vh;
  .lost-img{
    width: 280px;
    height: 240px;
  }
  .lost_title {
    font-size: 32px;
    font-weight: 600;
    color: #3A3B3C;
    line-height: 44px;
    text-align: center;
    margin-top: 24px;
  }
  .lost_text {
    margin-top: 16px;
    font-weight: 400;
    font-size: 28px;
    color: #979797;
    line-height: 40px;
  }
}
.error {
  position: absolute;
  top: 0;
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow-y: scroll;
  .is_error {
    width: 100vw;
  }
  .is_err_title {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    .is_err_img {
      width: 64px;
    }
    .is_err_text {
      font-weight: 500;
      font-size: 32px;
      color: #75270C;
      line-height: 48px;
      text-align: center;
      margin-left: 14px;
    }
    .error_text_tc {
      color: #FF5E31;
    }
  }
  .toast-title {
    font-weight: 500;
    font-size: 32px;
    color: #3A3B3C;
    line-height: 44px;
    text-align: center;
    font-style: normal;
    margin-bottom: 16px;
    margin-top: 24px;
  }
  .toast-body {
    font-weight: 500;
    font-size: 28px;
    color: #979797;
    line-height: 44px;
    text-align: center;
  }
}

.box1 {
  overflow: hidden;
  position: absolute;
  top: calc(50% - 68px);
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  z-index: 10;
}
 ::v-deep .van-icon {
    width: 32px;
    height: 32px;
    line-height: 40px;
    text-align: center;
   }
  ::v-deep .van-radio__label {
    margin-top: -3px !important;
}
::v-deep .van-field__control {
  caret-color: var(--text-base-color) !important;
}
::v-deep .van-cell {
    padding: 18px 24px !important;
}
::v-deep .van-field__button {
    padding-left: 8px;
    position: absolute;
    right: -18px;
    top: 8px;
}
::v-deep .mask {
    opacity: 0 !important;
}
@keyframes scroll {
  0% {
    transform: translateY(0);
  }
  10% {
    transform: translateY(0);
  }
  90% {
    transform: translateY(-100%);
  }
  100% {
    transform: translateY(-100%);
  }
}
@keyframes scroll-paused {
  // 0% {
  //   transform: translateY(0);
  // }
  // 100% {
  //   transform: translateY(0);
  // }
}
</style>
